import React, {FC} from 'react';

import {Modal, zIndex} from '@optimaxdev/design-system';

import s from './payPalModal.scss';

type PropsType = {
    closePopup: () => void;
    isOpened: boolean;
    payPalIframeURL: string;
};

/**
 * PayPalModal custom iframe for paypal pay over time
 *  @returns {React.ReactElement} - PayOverTimePopup popup
 */
export const PayPalModal: FC<PropsType> = ({closePopup, isOpened, payPalIframeURL}) => {
    return (
        <Modal
            isOpen={isOpened}
            onRequestClose={closePopup}
            options={{overflow: 'hidden', withBorderRadius: true}}
            overlay="dark"
            zIndex={zIndex.overlay}
        >
            <div className={s.popupContainer}>
                <iframe
                    height="100%"
                    src={payPalIframeURL}
                    title="Pay over time PayPal"
                    width="100%"
                />
            </div>
        </Modal>
    );
};
